import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";

import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import "flatpickr/dist/flatpickr.css";
import { Editor } from "components/shared/Editor";
import ImageUpload from "components/shared/ImageUpload";
import { Input } from "components/shared/FormComponents";

const EditService = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    loading,
    error,
    section,
    // sections: categories,
  } = useSelector((state) => state.section);

  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  // const [sliders, setSliders] = useState([]);
  // const categoryDefaultValue = categories?.find(
  //   (category) => category?.slug === section?.category
  // )?.heading?.[locale];

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  // effects
  useEffect(() => {
    dispatch(getSection({ page: "service-1", slug: id }));
    // dispatch(getAllPageSections("projectsCategories"));
  }, [dispatch, id]);

  useEffect(() => {
    reset(section);
    setSelectedImage({
      preview: null,
      path: section?.image,
    });
    // setSliders(section?.sections);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!selectedImage?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }

    data.image = `/uploads/${selectedImage?.path?.split("/").at(-1)}`;
    // data.sections = sliders;
    dispatch(
      editSection({
        slug: id,
        page: "service-1",
        data: { section: data },
        navigate: () => navigate("/service"),
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"editItem"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                {/* heading  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"image"} />
                      </h5>
                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col xs="12" md="6">
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> (
                        <FormattedMessage id="arabic" />)
                      </h5>

                      <Controller
                        control={control}
                        name={`description.ar`}
                        render={({ field: { value, onChange } }) => (
                          <Editor
                            type="text"
                            initialValue={value}
                            className={`form-control form-outline`}
                            onChange={(_, editor) => {
                              const data = editor.getContent();
                              onChange(data);
                            }}
                          />
                        )}
                      />
                    </div>
                  </Col>
                  <Col xs="12" md="6">
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} /> (
                        <FormattedMessage id="english" />)
                      </h5>

                      <Controller
                        control={control}
                        name={`description.en`}
                        render={({ field: { value, onChange } }) => (
                          <Editor
                            type="text"
                            initialValue={value}
                            className={`form-control form-outline`}
                            onChange={(_, editor) => {
                              const data = editor.getContent();
                              onChange(data);
                            }}
                          />
                        )}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        <FormattedMessage id={"add"} />
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditService;
